<template>
  <div id="dashboard">
    <transition name="fade">
      <comp-message
        v-if="showMessage"
        :msgText="messageText"
        :msgSuccess="!messageIsErr"
        :msgError="messageIsErr"
        @closeMsg="showMessage = false"
      />
    </transition>

    <div class="contents">
      <div class="column">
        <div class="row">
          <div class="block for-profile">
            <div class="profile-container">
              <div class="photo" :style="updatePhotoView()"></div>
              <div class="name">
                <span>{{ getUserName }}</span
                >{{ userType }}
              </div>
            </div>
            <div class="btn-container">
              <div class="btn" @click="openEditProfile">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path
                    d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                  ></path>
                  <path
                    d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                  ></path>
                </svg>
                Edit Profile
              </div>
              <div
                class="btn"
                @click="goPaymentPage"
                :style="updateRoomAndConnectionBtns()"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <circle cx="12" cy="8" r="7"></circle>
                  <polyline
                    points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"
                  ></polyline>
                </svg>
                Get My Report
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="block for-report" @click="onMyReportClick">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
              <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
            </svg>
            View My Result
          </div>
        </div>
        <div class="row" :style="updateRoomAndConnectionBtns()">
          <div class="block for-connections" @click="onConnectionClick">
            <div class="number">{{ conTotalCnt }}</div>
            <div class="title">Total Connections</div>
            <div class="sub">{{ conPendingCnt }} Pending invites</div>
          </div>
          <div class="block for-rooms" @click="onRoomClick">
            <div class="number">{{ roomTotalCnt }}</div>
            <div class="title">Total Rooms</div>
            <div class="sub">{{ roomPendingCnt }} Pending invites</div>
          </div>
        </div>
        <div class="row mobile-only">
          <div class="block for-milestones" @click="openMilestone">
            <div class="number">{{ milestonesCnt }}</div>
            <div class="title">To Go!</div>
            <div class="sub">{{ milestonesRate }} achieved</div>
          </div>
          <div
            class="block for-notifications"
            v-if="isAvailableAccessRoomAndConn"
            @click="goPage('notifications')"
          >
            <div class="number">{{ notificationCnt }}</div>
            <div class="title">Notifications</div>
            <!--            <div class="sub">Sampletext</div>-->
          </div>
        </div>
      </div>
      <div
        class="column milestone"
        v-if="milestone"
        :class="{ 'show-on-mobile': isMobile }"
      >
        <div class="block">
          <div class="number">Milestones</div>
          <div class="sub">
            Complete all 5 Milestones and<br />get your COBI Report for FREE!
          </div>
          <ul>
            <label v-for="(item, index) in milestonesList" :key="index">
              <li :class="{ done: item.isDone }">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                {{ `${item.content}` }}
                <template v-if="!isOnlyOneQuest(item.progress)">
                  {{ ` ${item.progress}` }}
                </template>
                <button
                  v-if="item.milestoneSeqId === 2 && !item.isDone"
                  class="resend"
                  @click="resendMail"
                >
                  Resend
                </button>
                <button
                  class="resend"
                  v-else-if="item.milestoneSeqId >= 4 && !item.isDone"
                  @click="goMilestone(item.milestoneSeqId)"
                >
                  Go
                </button>
              </li>
            </label>
          </ul>
          <div
            class="reward"
            v-if="isAllMilestoneDone"
            @click="onGetMyReportMissionComplete"
          >
            Get My Report
          </div>
        </div>

        <div class="btn-close" @click="closeMilestone">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>
      </div>
      <div class="column notification" v-if="isAvailableAccessRoomAndConn">
        <div class="block" @click="goPage('notifications')">
          <div class="number">{{ notificationCnt }}</div>
          <div class="title">Notifications</div>
          <!--          <div class="sub">Sampletext</div>-->
          <ul>
            <li
              v-for="(item, index) in notificationList"
              :key="index"
              @click.stop="onNotiClick(item.alertSeqId, item.type)"
            >
              <div
                class="photo"
                :style="{
                  backgroundImage: `url(data:image/png;base64,${item.profileImage})`
                }"
              ></div>
              <div class="txt">{{ item.alertContent }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="modal full-on-mobile" id="edit-profile" v-if="modalEditProfile">
      <div class="modal-contents">
        <div class="modal-header">Edit Profile</div>
        <div class="modal-body">
          <div class="form-group">
            <div class="profile-photo">
              <div class="label">Profile Photo</div>
              <div class="photo-wrapper">
                <div class="photo-container" :style="updatePhotoView()"></div>
                <div class="button-container">
                  <input
                    type="file"
                    class="btn-upload"
                    @change="fileSelect($event.target.files)"
                    @click="fileUploadClick"
                    ref="docFile"
                    accept=".jpg, .jpeg, .png"
                    id="fileEvent"
                    hidden
                  />
                  <div class="btn-upload" @click="clickTrigger">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <rect
                        x="3"
                        y="3"
                        width="18"
                        height="18"
                        rx="2"
                        ry="2"
                      ></rect>
                      <circle cx="8.5" cy="8.5" r="1.5"></circle>
                      <polyline points="21 15 16 10 5 21"></polyline>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-container">
              <label class="label" for="email">Name</label>
              <input
                type="text"
                name=""
                id="firstname"
                v-model.trim="firstname"
              />
              <input
                type="text"
                name=""
                id="lastname"
                v-model.trim="lastname"
              />
            </div>
            <div class="form-container">
              <div class="label">Gender</div>
              <input
                type="radio"
                id="female"
                value="F"
                name="gender"
                v-model="genderValue"
              />
              <label for="female">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="checked"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="unchecked"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                </svg>
                <span>Female</span>
              </label>
              <input
                type="radio"
                id="male"
                value="M"
                name="gender"
                v-model="genderValue"
              />
              <label for="male">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="checked"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="unchecked"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                </svg>
                <span>Male</span>
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="button-group">
            <div class="button-container">
              <div class="button" @click="closeEditProfile">Cancel</div>
            </div>
            <div class="button-container">
              <div class="button" @click="putUserInfo">
                <comp-loading v-if="isLoading"></comp-loading>
                <div v-else>OK</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <comp-loading v-if="isLoading" :fullscreen="true"></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common'
import UserService from '@/services/user-service'
import ReportService from '@/services/report-service'
import NotificationService from '@/services/notification-service'
import CompMessage from '@/components/CompMessage'
import CompLoading from '@/components/CompLoading'

export default {
  name: 'Dashboard',
  mixins: [common],
  components: {
    CompMessage,
    CompLoading
  },
  created() {
    this.$parent.setNav(true)
    this.$parent.setHeader(this.pageTitle)
    this.$parent.setBottomTab(true)
    this.$EventBus.$on('editProfile', () => {
      this.modalEditProfile = true
    })

    this.getDashboard()
  },
  mounted() {
    window.addEventListener('resize', this.checkWidthForMilestone)
    this.checkWidthForMilestone()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkWidthForMilestone)
  },
  data() {
    return {
      pageTitle: 'Dashboard',

      showMessage: false,
      messageText: '',
      messageIsErr: false,

      firstnameType: 'text',
      firstname: '',
      firstnameValue: '',

      lastnameType: 'text',
      lastname: '',
      lastnameValue: '',

      genderValue: '',
      checkValue: Boolean,
      settingEditProfile: false,

      roomPendingCnt: '',
      roomTotalCnt: '',
      conPendingCnt: '',
      conTotalCnt: '',
      milestonesRate: '',
      milestonesList: [],
      milestonesCnt: '',

      userProfileLink: '',
      userType: '',
      notificationCnt: '',
      notificationList: [],

      modalEditProfile: false,
      milestone: false,
      mailResend: false,
      milestoneStatus: false,
      profileImg: '',

      isLoading: false
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile
    },
    getUserName() {
      if (this.isEmpty(this.firstname)) {
        return 'Unknown'
      }
      return `${this.firstname} ${this.lastname}`
    },
    isAvailableAccessRoomAndConn() {
      return this.$store.state.auth.isUserPermitAll
    },
    isAllMilestoneDone() {
      const isCompletedList = []
      this.milestonesList.forEach((milestone) => {
        if (milestone.isDone) isCompletedList.push(milestone)
      })

      if (isCompletedList.length === 0) return false
      return isCompletedList.length === this.milestonesList.length
    }
  },
  methods: {
    isOnlyOneQuest(milestoneProgress) {
      const lastChar = milestoneProgress.slice(-1)
      return lastChar === '1'
    },
    updateRoomAndConnectionBtns() {
      if (this.isAvailableAccessRoomAndConn) {
        return { opacity: 1.0 }
      }
      return { opacity: 0.2 }
    },
    showInfoMessage(message, isError) {
      this.isLoading = false

      this.showMessage = true
      this.messageText = message
      this.messageIsErr = isError || false

      setTimeout(() => {
        this.showMessage = false
        this.messageText = ''
        this.messageIsErr = false
      }, 2000)
    },
    updatePhotoView() {
      if (this.userProfileLink) {
        return {
          backgroundImage: `url(data:image/png;base64,${this.userProfileLink})`
        }
      }
    },
    openEditProfile() {
      this.modalEditProfile = true
    },
    closeEditProfile() {
      this.modalEditProfile = false
    },
    openMilestone() {
      this.milestone = true
    },
    closeMilestone() {
      this.milestone = false
    },
    getDashboard() {
      this.isLoading = true

      UserService.getDashboard().then(({ resultCode, resultData }) => {
        this.isLoading = false

        if (resultCode === 0) {
          this.roomPendingCnt = resultData.rooms.pendingCount
          this.roomTotalCnt = resultData.rooms.totalCount
          this.milestonesRate = resultData.milestone.completeRate
          this.milestonesList = resultData.milestone.list
          this.milestonesCnt = resultData.milestone.completeCount
          this.notificationCnt = resultData.notifications.totalCount
          this.notificationList = resultData.notifications.list
          this.conPendingCnt = resultData.connections.pendingCount
          this.conTotalCnt = resultData.connections.totalCount

          var isPermitAllow = true
          this.milestonesList.forEach((milestone) => {
            if (milestone.milestoneSeqId === 2) {
              this.mailResend = milestone.isDone
              if (!milestone.isDone) isPermitAllow = false
            } else if (milestone.milestoneSeqId === 3) {
              if (!milestone.isDone) isPermitAllow = false
            }
          })
          if (this.milestonesList.length === 0) isPermitAllow = false
          this.$store.commit('setUserPermitAll', isPermitAllow)

          this.userProfileLink = resultData.user.profileImage
          this.firstname = resultData.user.firstName
          this.lastname = resultData.user.lastName
          this.userType = resultData.user.type
          if (resultData.user.sex === 'M') {
            this.genderValue = 'M'
          } else {
            this.genderValue = 'F'
          }

          const landingCode = this.$store.state.landingCode
          if (!this.isEmpty(landingCode) && isPermitAllow) {
            this.goPage('connections')
          }
        }
      })
    },
    async putUserInfo() {
      this.isLoading = true

      const param = {
        firstName: this.firstname,
        lastName: this.lastname,
        sex: this.genderValue,
        file: this.profileImg
      }
      await UserService.putUserInfo(param).then((data) => {
        this.isLoading = false

        if (data.resultCode === 0) {
          this.modalEditProfile = false
          this.getDashboard()
        }
      })
    },
    resendMail() {
      this.isLoading = true

      // 인증메일 발송
      UserService.sendAuthEmail().then(({ resultCode, resultMsg }) => {
        this.showInfoMessage(resultMsg, resultCode !== 0)
      })
    },
    goMilestone(milestoneId) {
      switch (milestoneId) {
        case 4: // Invite Friends
          this.$parent.goConnected()
          break
        case 5: // Create A Room
          this.$parent.goRooms()
      }
    },
    onGetMyReportMissionComplete() {
      this.isLoading = true

      // 인증메일 발송
      ReportService.getMyReportMissionComplete().then(
        ({ resultCode, resultMsg }) => {
          this.showInfoMessage(resultMsg, resultCode !== 0)
        }
      )
    },
    onMyReportClick() {
      if (this.isAvailableAccessRoomAndConn) {
        this.goPage('report')
      } else {
        this.showVerifyDialog()
      }
    },
    onConnectionClick() {
      if (this.isAvailableAccessRoomAndConn) {
        this.goPageWithParams('Connections', { listType: 'connected' })
      } else {
        this.showVerifyDialog()
      }
    },
    onRoomClick() {
      if (this.isAvailableAccessRoomAndConn) {
        this.goPageWithParams('Rooms', { listType: 'roomConnected' })
      } else {
        this.showVerifyDialog()
      }
    },
    onNotiClick(seqId, type) {
      this.isLoading = true

      if (this.isAvailableAccessRoomAndConn) {
        if (type === 'room_invite') {
          this.goPageWithParams('Rooms', { listType: 'roomReceived' })
        } else if (type === 'connection_invite') {
          this.goPageWithParams('Connections', { listType: 'received' })
        }
        NotificationService.deleteAlarms(seqId).then(({ resultCode }) => {
          this.isLoading = false

          if (resultCode === 0) {
            this.getDashboard()
          }
        })
      } else {
        this.isLoading = false
      }
    },
    fileUploadClick() {
      this.$refs.docFile.click()
    },
    clickTrigger() {
      var ele = document.getElementById('fileEvent')
      ele.click()
    },
    fileSelect(files) {
      if (files[0]) {
        this.resizeImage({
          file: files[0],
          maxSize: 500
        }).then((resizedImage) => {
          const imgSize = resizedImage.size
          const maxSize = 5 * 1024 * 1024

          if (imgSize > maxSize) {
            this.$parent.showDialog(
              'Error',
              'Photos larger than 5MB cannot be uploaded.',
              () => {}
            )
          } else {
            const photoView = this.$el.querySelector('.photo-container')
            const reader = new FileReader()

            reader.onloadend = () => {
              photoView.style.backgroundImage = `url(${reader.result})`
            }
            reader.readAsDataURL(resizedImage)
            this.profileImg = this.convertBlobToFile(
              resizedImage,
              'profile.jpg'
            )
          }
        })
      }
    },
    goPaymentPage() {
      if (this.isAvailableAccessRoomAndConn) {
        this.goPage('payment')
      } else {
        this.showVerifyDialog()
      }
    },
    showVerifyDialog() {
      UserService.getMilestone().then((data) => {
        this.isLoading = false

        this.milestoneList = data.list
        var isPermitAllow = true
        this.milestonesList.forEach((milestone) => {
          if (milestone.milestoneSeqId === 2) {
            this.mailResend = milestone.isDone
            if (!milestone.isDone) isPermitAllow = false
          } else if (milestone.milestoneSeqId === 3) {
            if (!milestone.isDone) isPermitAllow = false
          }
        })
        if (this.milestonesList.length === 0) isPermitAllow = false
        this.$store.commit('setUserPermitAll', isPermitAllow)

        this.isLoading = false

        if (isPermitAllow) {
          this.showInfoMessage('All features have been unlocked.', false)
          this.getDashboard()
        } else {
          this.$parent.showDialog(
            'Wait',
            'Please fill out your profile and verify E-mail.',
            () => {
              this.modalEditProfile = true
            }
          )
        }
      })
    },
    checkWidthForMilestone() {
      if (document.documentElement.clientWidth < 720) {
        this.closeMilestone()
      } else if (document.documentElement.clientWidth >= 720) {
        this.openMilestone()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="../scss/dashboard.scss" scoped></style>
